import React from "react";
import styled from "styled-components";
import IconSvg from "../IconSvg/IconSvg";
import Box from "../Box/Box";
import Text from "../Text/Text";

const ProfileImage = styled.img`
  background: #E8EAFD;
  width: 24px;
  height: 24px;
  border-radius: 2em;
  margin-right: 0.5em;
`;

const HeaderProfile = ({ name }) => (
  <Box bgColor='white' flex spacing='p-2' alignItems='center'>
    <ProfileImage />
    <Text bold spacing='pr-1'>{name}</Text>
    <IconSvg icon='chevron-down' spacing='mr-3' />
    <IconSvg icon='bell' />
  </Box>
);

HeaderProfile.defaultProps = {
  name: "Jonathan Doe"
};

export default HeaderProfile;

